// extracted by mini-css-extract-plugin
export default {"information":"_ee2fac19","rowContainerWrapper":"_1b16552b"};